module.exports = __webpack_public_path__ + "img/person-digging.235e623c.svg";